<aside class="sidebar" *ngIf="!isPrescriber">
	<div
		class="mt-3 d-flex"
		[ngClass]="{
			'justify-content-center': isSidebardHidden,
			'justify-content-end me-4': !isSidebardHidden
		}"
	>
		<button
			title="Afficher/cacher le menu"
			class="btn nav-link"
			(click)="toggleSidebarPin()"
		>
			<i
				*ngIf="isSidebardHidden"
				class="bi bi-list topbar-blue-button fs-1"
				aria-hidden="true"
			></i>
			<i
				*ngIf="!isSidebardHidden"
				class="bi bi-arrow-left topbar-blue-button fs-2"
				aria-hidden="true"
			></i>
		</button>
	</div>
	<!--
	<div
		class="sidebar-profile d-flex flex-column justify-content-center pt-3 pb-3"
	>
		
		<div class="profile-details text-center pb-4 pt-4">
			<p class="mb-0 text-uppercase name">
				{{ currentUserLoggedIn.employee.firstName }}
				{{ currentUserLoggedIn.employee.lastName }}
			</p>
			<small class="text-uppercase role">{{
				currentUserLoggedIn.role.name
			}}</small>
		</div>
	</div>
	-->
	<nav class="sidebar-menu pt-3 pb-3">
		<!-- <div class="menu-header mt-3 mb-2">Components</div> -->
		<ul class="menu-items">
			<li *ngFor="let menuItem of menuItems">
				<button
					[title]="menuItem.name"
					[routerLink]="[menuItem.path]"
					routerLinkActive="fw-bolder"
				>
					<i [class]="menuItem.iconClass" aria-hidden="true"></i>
					<span class="fs-6">{{ menuItem.name }}</span>
					<!-- <span class="badge badge-warning rounded-0 text-dark p-1">NEW</span> -->
				</button>
			</li>
		</ul>
	</nav>
</aside>
